import React from "react";
import PropTypes from "prop-types";
import stylesModule from "./SideItem.module.sass";
import { useLocation } from "react-router-dom";

const SideItem = props => {
  const { onClick, icon, label, path, id } = props;
  const location = useLocation();

  const handleMatchPath = path => {
    return location.pathname.split("/").includes(id);
  };

  return (
    <li className={stylesModule.sideItem}>
      <button
        onClick={onClick}
        className={`${stylesModule.linkToItem} ${
          handleMatchPath(path) && stylesModule.optionSelected
        }`}
      >
        {icon && <span className={stylesModule.icon}>{icon}</span>}
        {label}
      </button>
    </li>
  );
};

SideItem.propTypes = {
  icon: PropTypes.node,
  onClick: PropTypes.func,
  label: PropTypes.object.isRequired,
  path: PropTypes.string,
  id: PropTypes.string
};

export default SideItem;
